import * as act from '@/store/filefolders.actions';
import store from './store';

const state = {
  currentFileFolderName: '',
  parentFolderCode: null
};

const actions = {
  [act.ACT_CURFOLDERSET]({ commit }, { name, parentCode }) {
    commit(act.MUT_CURFOLDERSET, { name, parentCode });
  }
};

const mutations = {
  [act.MUT_CURFOLDERSET](state: any, { name, parentCode }): void {
    state.currentFileFolderName = name;
    state.parentFolderCode = parentCode;
  }
};

const getters = {
  [act.GET_CURFOLDER]: state => {
    return { name: state.currentFileFolderName, parentCode: store.parentFolderCode };
  }
};

export const filefolders = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
